import React, { useCallback, useState, useEffect } from 'react'
import { hooks, PhoneVerification } from '@adc/ui-adc'
import { useListingContext } from '../context/listing'

const hasUserSelectedOptin = userPhones => {
  if (!userPhones) return true
  if (!userPhones.length) return false
  const latestPhone = PhoneVerification.utils.getLatestPhone(userPhones)
  return typeof latestPhone.opt_in === 'boolean'
}

export const withNudgeHook = WrappedComponent => originalProps => {
  const { user, openOptInModal } = originalProps
  const [shouldDisplayModal, setShouldDisplayModal] = useState(false)
  const { data, actions } = hooks.useWebApplicationNudges()
  const { listing } = useListingContext()
  const { nudge } = actions

  const isPropertySaved = listing?.primary_property?.is_currently_saved

  const isModalEnabledToDisplay = useCallback(() => {
    if (!isPropertySaved || hasUserSelectedOptin(user.party?.phones)) {
      return false
    }
    return true
  }, [isPropertySaved, user.party])

  useEffect(() => {
    if (shouldDisplayModal) {
      if (data.active.has('sms_opt_in') && isModalEnabledToDisplay()) {
        openOptInModal()
        setShouldDisplayModal(false)
      }
    }
  }, [
    shouldDisplayModal,
    data.active,
    openOptInModal,
    setShouldDisplayModal,
    isModalEnabledToDisplay,
  ])

  useEffect(() => {
    if (shouldDisplayModal && isModalEnabledToDisplay()) {
      nudge('sms_opt_in')
    }
  }, [shouldDisplayModal, isModalEnabledToDisplay, nudge])

  const nudgeOptInModal = () => setShouldDisplayModal(true)

  return (
    <WrappedComponent {...originalProps} nudgeOptInModal={nudgeOptInModal} />
  )
}
